import { Box, Button, Inline, Stack } from 'braid-design-system';


import type { SocialProvider } from '../../../types';

import { SocialDivider } from './SocialDivider';
import { AppleIcon } from './icons/AppleIcon';
import { FacebookIcon } from './icons/FacebookIcon';
import { GoogleIcon } from './icons/GoogleIcon';

export const ProviderOAuthMap: Record<SocialProvider, string> = {
  google: 'google-oauth2',
  facebook: 'facebook',
  apple: 'apple',
};


interface SocialButtonProps{
  callback: (socialProvider: string) => void;
}

interface RenderProviderProps {
  onClick: (provider: SocialProvider) => void;
}

const RenderSocialProvider = ({ children, label, onClick }: any) => {

  return (
    <Button tone="neutral" variant="ghost" onClick={onClick}>
      <Box
        position="absolute"
        left={0}
        marginLeft={{ mobile: 'small', tablet: 'gutter' }}
      >
        {children}
      </Box>
      <Inline space="small" align="center">
        <Box paddingLeft={{ mobile: 'small', tablet: 'none' }}>{label}</Box>
      </Inline>
    </Button>
  );
};

const renderFacebook = ({ onClick }: RenderProviderProps) => (
  <RenderSocialProvider
    label="Continue with Facebook"
    key="facebook"
    onClick={() => onClick('facebook')}
  >
    <FacebookIcon height={24} width={24} />
  </RenderSocialProvider>
);

const renderGoogle = ({ onClick }: RenderProviderProps) => (
  <RenderSocialProvider
    label="Continue with Google"
    onClick={() => onClick('google')}
    key="google"
  >
    <GoogleIcon height={24} width={24} />
  </RenderSocialProvider>
);

const renderApple = ({ onClick }: RenderProviderProps) => (
  <RenderSocialProvider
    label="Continue with Apple"
    key="apple"
    onClick={() => onClick('apple')}
  >
    <AppleIcon height={24} width={24} />
  </RenderSocialProvider>
);


const SocialButtons = ({callback}: SocialButtonProps) => {


  const providerButtons: any[] = [renderGoogle, renderFacebook, renderApple];

  const onClick = (provider: SocialProvider) => {

    callback(ProviderOAuthMap[provider]);
  };

  return (
    <span data-testid="social-providers">
      <SocialDivider />
      <Stack space="small">
        {providerButtons.map((providerButton) => providerButton({ onClick }))}
      </Stack>
    </span>
  );
};

export default SocialButtons;
